<div class="chat-container">
  <div class="chat__content chat-list__container" id="feed-messages-container"
       infinite-scroll
       [infiniteScrollDistance]="scrollDownDistance"
       [infiniteScrollThrottle]="throttle"
       [scrollWindow]="false"
       (scrolled)="addVehicles(false)">
    <div *ngIf="vehicles == null || vehicles.length == 0" class="alert alert-info text-center" role="alert">
      {{(vehicleListMode === VehicleListMode.ALL ? 'chat.list.no-vehicles' : 'chat.list.no-subs-vehicles') | translate}}
    </div>
    <div class="tray-list__message" *ngFor="let vehicle of showingVehicles; trackBy: trackByVehicleId">
      <div class="message__status">
        <span class="message__icon"
      (click)="openChat(vehicle)"
      [ngClass]="{'message--offline': displayInfo.get(vehicle.id) != null
                        && !displayInfo.get(vehicle.id).tabOnline,
                 'message--online': displayInfo.get(vehicle.id) != null
                        && displayInfo.get(vehicle.id).tabOnline,
                 'message--new': displayInfo.get(vehicle.id) != null
                        && displayInfo.get(vehicle.id).newMessagesCount > 0}"></span>
      </div>
      <div class="message__details" (click)="openChat(vehicle)">
        <div class="message__author">
          <span class="author text-capitalize">{{vehicle.plateNumber}}</span>
          <span class="driver-name" *ngIf="vehicle.driverName">({{vehicle.driverName}})</span>
        </div>
        <span class="message__timestamp">
          {{displayInfo.get(vehicle.id)?.lastSentOn}}
        </span>
        <div class="message__text">
          {{displayInfo.get(vehicle.id)?.lastMessage}}
        </div>
      </div>
      <a class="icon-action scan-doc-button"
         (click)="openScannedDocs(vehicle)">
        <i class="ico-paperclip "></i>
      </a>
    </div>
  </div>
  <div class="chat__filter chat-list__filter form--soft d-flex">
    <div class="switch">
      <a class="switch__item"
         [ngClass]="{'switch__item--active': vehicleListMode === VehicleListMode.SUBSCRIBED}"
         (click)="toggleVehicleListMode(VehicleListMode.SUBSCRIBED)"
         [ngbTooltip]="'chat.list.subscribed' | translate"
         tabindex="1">
        <i class="ico-truck-check"></i>
      </a>
      <a class="switch__item"
         [ngClass]="{'switch__item--active': vehicleListMode === VehicleListMode.ALL}"
         (click)="toggleVehicleListMode(VehicleListMode.ALL)"
         [ngbTooltip]="'chat.list.allVehicles' | translate"
         tabindex="2">
        <i class="ico-truck"></i>
      </a>
    </div>
    <div class="input-group">
      <input class="form-control" type="text" (keyup)="filterVehicles($event.target.value)">
      <div class="chat-header__button"><i class="ico-search"></i></div>
    </div>
    <button class="chat-header__button" (click)="markAllRead()" [ngbTooltip]="'chat.list.readAll' | translate">
      <i class="ico-mail-open-all"></i>
    </button>
  </div>
</div>

